import React, { useState, useEffect } from "react";
import { getDatabase, ref, get, set } from "firebase/database";
import { getAuth } from "firebase/auth";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import joiningPayqr from '../images/joining-qr.jpg';

export default function DashBoardNonVerified() {
    const auth = getAuth();
    const db = getDatabase();
    const user = auth.currentUser;
    const navigate = useNavigate();
    const [hasPaid, setHasPaid] = useState(false);
    const [formData, setFormData] = useState({ transactionId: "", tdrId: "" });
    const [loading, setLoading] = useState(false);
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        if (user) {
            const payRef = ref(db, `blackstone-users/${user.uid}/joiningPay`);
            get(payRef).then((snapshot) => {
                if (snapshot.exists()) {
                    setHasPaid(true);
                }
                setChecking(false);
            });
        }
    }, [user]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // ⭐⭐⭐ UPDATED PAYMENT SUBMIT + REFERRAL BONUS CODE ⭐⭐⭐
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.transactionId || !formData.tdrId) {
            Swal.fire({
                icon: "warning",
                title: "All fields are required",
            });
            return;
        }

        setLoading(true);

        try {
            const userRef = ref(db, `blackstone-users/${user.uid}`);
            const userSnap = await get(userRef);

            if (!userSnap.exists()) {
                throw new Error("User data not found.");
            }

            const userData = userSnap.val();
            const referralBy = userData.referralBy || null;

            // 1️⃣ Save joining payment details
            await set(ref(db, `blackstone-users/${user.uid}/joiningPay`), {
                transactionId: formData.transactionId,
                tdrId: formData.tdrId,
                paidAt: new Date().toISOString(),
                verified: false,
            });

            // 2️⃣ If referral exists → Add ₹50 bonus to referrer
            if (referralBy) {
                const referralRef = ref(db, `blackstone-users/${referralBy}`);
                const referralSnap = await get(referralRef);

                if (referralSnap.exists()) {
                    const refUserData = referralSnap.val();
                    const oldBalance = refUserData.walletBalance || 0;
                    const newBalance = oldBalance + 50;

                    await set(ref(db, `blackstone-users/${referralBy}/walletBalance`), newBalance);
                }
            }

            Swal.fire({
                icon: "success",
                title: "Payment submitted successfully!",
                text: "Waiting for admin verification.",
            });

            setHasPaid(true);

        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message,
            });
        } finally {
            setLoading(false);
        }
    };

    if (checking) {
        return (
            <div
                className="d-flex justify-content-center align-items-center vh-100"
                style={{ backgroundColor: "#87CEEB" }}
            >
                <div className="spinner-border text-light" role="status"></div>
            </div>
        );
    }

    return (
        <div
            className="d-flex justify-content-center align-items-center vh-100"
            style={{ backgroundColor: "#87CEEB" }}
        >
            <div
                className="d-flex w-75 shadow-lg justify-content-center align-items-center"
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    overflow: "hidden",
                    minHeight: "400px",
                }}
            >
                {hasPaid ? (
                    <div className="text-center p-5">
                        <h3 className="text-success fw-bold">✅ You have already paid</h3>
                        <p className="mt-3">
                            You can login through your dashboard once the admin verifies your details.
                        </p>
                        <button
                            className="btn btn-primary mt-3"
                            onClick={() => navigate("/")}
                        >
                            Return to Home
                        </button>
                    </div>

                ) : (
                    <div className="row w-100">
                        {/* Left section: QR */}
                        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center p-4">
                            <img
                                src={joiningPayqr}
                                alt="Scan to Pay"
                                style={{ width: "80%", height: "80%", objectFit: "contain" }}
                            />

                            {/* Highlighted Joining Fees Line */}
                            <div
                                style={{
                                    marginTop: "15px",
                                    background: "#ffe08a",
                                    padding: "8px 15px",
                                    borderRadius: "8px",
                                    fontWeight: "bold",
                                    fontSize: "18px",
                                    color: "#444",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                                }}
                            >
                                Joining Fees: ₹500
                            </div>
                        </div>

                        {/* Right section: Payment form */}
                        <div className="col-md-6 p-4 d-flex flex-column justify-content-center">
                            <h3 className="fw-bold mb-3">Enter Payment Details</h3>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label fw-bold">Transaction ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="transactionId"
                                        value={formData.transactionId}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-bold">TDR ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="tdrId"
                                        value={formData.tdrId}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-primary w-100"
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit Payment"}
                                </button>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
